const STORAGE_KEY = 'welty.pwaInstallBanner.dismissedAt';
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

export function wasPwaInstallBannerDismissedRecently(): boolean {
  if (typeof localStorage === 'undefined') return false;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return false;
  const t = Number(raw);
  if (Number.isNaN(t)) return false;
  return Date.now() - t < SEVEN_DAYS_MS;
}

export function markPwaInstallBannerDismissed(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, String(Date.now()));
}
